import { Seo } from "../../components/Seo";
import { Alert } from "../../components/ui";
import { useLanguage } from "../../i18n/LanguageProvider";

export const TermsPage = () => {
  const { t } = useLanguage();

  const sections = [
    ["legal.termsEducationalHeading", "legal.termsEducationalBody"],
    ["legal.termsAccountHeading", "legal.termsAccountBody"],
    ["legal.termsContentHeading", "legal.termsContentBody"],
    ["legal.termsAvailabilityHeading", "legal.termsAvailabilityBody"],
  ] as const;

  return (
    <>
      <Seo
        titleKey="meta.terms.title"
        descriptionKey="meta.terms.description"
      />

      <section className="gw-section">
        <div className="gw-container gw-container--narrow">
          <h1 className="gw-title">{t("legal.termsTitle")}</h1>

          <div className="gw-stack-lg gw-prose" style={{ marginTop: "2.5rem" }}>
            {sections.map(([heading, body]) => (
              <section key={heading}>
                <h2
                  style={{
                    fontSize: "var(--gw-text-lg)",
                    marginBottom: "0.6rem",
                  }}
                >
                  {t(heading)}
                </h2>
                <p style={{ color: "var(--gw-ink-muted)" }}>{t(body)}</p>
              </section>
            ))}
          </div>

          <div style={{ marginTop: "2rem" }}>
            <Alert tone="warning" title={t("legal.termsCrisisHeading")}>
              {t("legal.termsCrisisBody")}
            </Alert>
          </div>
        </div>
      </section>
    </>
  );
};
